import React from "react";
import { Avatar, Box, Button, DialogActions, DialogContent, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { theme } from "../../theme";
import { resolveImageUrl } from "../../services/apiUtils";

type EntityDetailDialogProps = {
  open: boolean;
  onClose: () => void;
  icon: React.ReactNode;
  thumbnail?: string;
  title: string;
  subtitle: string;
  editTo: string;
  editLabel?: string;
  children: React.ReactNode;
};

const EntityDetailDialog: React.FC<EntityDetailDialogProps> = ({
  open,
  onClose,
  icon,
  thumbnail,
  title,
  subtitle,
  editTo,
  editLabel = "Edit",
  children,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
  >
    <Box
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, #FDB44D 100%)`,
        color: "#fff",
        px: 3,
        py: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Avatar
        variant="rounded"
        src={resolveImageUrl(thumbnail) || undefined}
        sx={{ bgcolor: "rgba(255,255,255,0.2)", width: 48, height: 48 }}
      >
        {icon}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h6" fontWeight="bold" noWrap>
          {title || "Untitled"}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>

    <DialogContent sx={{ pt: 3 }}>{children}</DialogContent>

    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button onClick={onClose} variant="outlined">
        Close
      </Button>
      <Button component={Link} to={editTo} variant="contained" startIcon={<EditIcon />}>
        {editLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default EntityDetailDialog;
